import Content from "./content";
import { IMapyBoxItem } from "~/interfaces";
import { createMyMapsSharing } from "~/ui/mymaps/sharing";
import { createUserNote } from "~/ui/user-note/note";
import { addListener, removeListener } from "~/lib/signals";
import { getNoteVersion, isPremiumNoteUser } from "~/util/user-note";
import MyMapsBox from "~/ui/mymaps/box";

export default class MymapsPlace extends Content {
	_mymapsBox: MyMapsBox;

	_userNote: ReturnType<typeof createUserNote>;

	_printList: string;

	constructor(data, options) {
		super(data, options);

		this._myBuild();
	}

	_myBuild() {
		this._dom.container.classList.add("content-mymaps-place");

		const { data: detailData, likeData } = this._data;
		const data: IMapyBoxItem = likeData
			? "data" in likeData ? likeData.data : likeData
			: null;

		this._printList = addListener(this, "print-page", "_printPage");

		if (data) {
			if (data.foreign) {
				this._dom.container.append(createMyMapsSharing({
					data,
				}));

				if (data.description) {
					this._userNote = createUserNote({
						data,
						foreign: true,
					});

					this._dom.container.append(this._userNote.container);
				}
			} else {
				const mymapsBox = new MyMapsBox({
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					data,
					folder: {
						id: data.parent_id,
						title: data.parent_name,
					},
					onSignal: signal => {
						switch (signal.name) {
							case "like-update":
								Mapy.getComponent("places").listRefreshData();
								break;

							case "delete":
								Mapy.getComponent("places").removeItemFromLikeList(detailData.source, detailData.id);
								this._mymapsBox.destroy();
								this._mymapsBox = null;
								Mapy.getComponent("detail").clearLikeData();
								break;

							case "like-move":
								/* eslint-disable camelcase */
								data.parent_id = signal.folderId;
								data.parent_name = signal.folderTitle;
								break;

							default:
						}
					},
				});

				this._mymapsBox = mymapsBox;
				this._dom.container.append(mymapsBox.container);
			}
		}
	}

	_printPage() {
		this._userNote?.print();
		this._mymapsBox?.print();
	}

	destroy(): void {
		if (this._mymapsBox) {
			this._mymapsBox.destroy();
		}

		if (this._userNote) {
			this._userNote.destroy();
		}

		removeListener(this._printList);
	}
}
